import * as React from 'react';
import { createContext, useState, useMemo } from 'react';
import { GraphContextType, MessageContextType, ProgressContextType, TenantContextType, UserContextType } from '../interfaces/ContextType';
import { MessageBarType } from '@fluentui/react';
import SettingsCompany from '../helpers/SettingsCompany';
import { UserAdminItem } from '../interfaces/UserAdminItem';
import { GraphUser } from '../interfaces/GraphUser';
import { GraphOrganizationData } from '../interfaces/GraphOrganizationData';

export const MessageContext = createContext({
  messageContext: {} as MessageContextType,
  setMessageContext: {} as React.Dispatch<React.SetStateAction<MessageContextType>>
});
export const GraphContext = createContext({
  graphContext: {} as GraphContextType,
  setGraphContext: {} as React.Dispatch<React.SetStateAction<GraphContextType>>
});
export const TenantContext = createContext({
  tenantContext: {} as TenantContextType,
  setTenantContext: {} as React.Dispatch<React.SetStateAction<TenantContextType>>
});
export const UserContext = createContext({
  userContext: {} as UserContextType,
  setUserContext: {} as React.Dispatch<React.SetStateAction<UserContextType>>
});
export const ProgressContext = createContext({
  progressContext: {} as ProgressContextType,
  setProgressContext: {} as React.Dispatch<React.SetStateAction<ProgressContextType>>
});

const ContextWrapper: React.FC = ({ children }) => {
  const [messageContext, setMessageContext] = useState<MessageContextType>({
    messageType: MessageBarType.info,
    message: '',
    visible: false
  });

  const [graphContext, setGraphContext] = useState<GraphContextType>({
    userPhoto: '',
    userDetails: {} as GraphUser,
    compDetails: {} as GraphOrganizationData,
  });

  const [tenantContext, setTenantContext] = useState<TenantContextType>({
    tenantName: '',
    api: '',
    apiUri: '',
    groupIds: [],
    logo: '',
    settings: {} as SettingsCompany,
    templateVersion: 'TEST',
    MyTenant: false,
    companyGroups: [],
    allGroups: [],
    myGroups: [],
    simulatedGroups: undefined,
  });

  const [userContext, setUserContext] = useState<UserContextType>({
    userData: {} as UserAdminItem,
    excel2User: null,
    adminMode: false
  });

  const [progressContext, setProgressContext] = useState<ProgressContextType>({
    label: '',
    description: '',
    visible: false
  });

  // useEffect(() => {
  //   const storedGraphContext = localStorage.getItem('graphContext');
  //   const storedTenantContext = localStorage.getItem('tenantContext');
  //   const storedUserContext = localStorage.getItem('userContext');

  //   if (storedGraphContext) setGraphContext(JSON.parse(storedGraphContext));
  //   if (storedTenantContext) setTenantContext(JSON.parse(storedTenantContext));
  //   if (storedUserContext) setUserContext(JSON.parse(storedUserContext));
  // }, []);

  // useEffect(() => {
  //   localStorage.setItem('graphContext', JSON.stringify(graphContext));
  //   localStorage.setItem('tenantContext', JSON.stringify(tenantContext));
  //   localStorage.setItem('userContext', JSON.stringify(userContext));
  // }, [graphContext, tenantContext, userContext]);

  const messageValue = useMemo(() => ({ messageContext, setMessageContext }), [messageContext, setMessageContext]);
  const graphValue = useMemo(() => ({ graphContext, setGraphContext }), [graphContext, setGraphContext]);
  const tenantValue = useMemo(() => ({ tenantContext, setTenantContext }), [tenantContext, setTenantContext]);
  const userValue = useMemo(() => ({ userContext, setUserContext }), [userContext, setUserContext]);
  const progressValue = useMemo(() => ({ progressContext, setProgressContext }), [progressContext, setProgressContext]);

  return (
    <MessageContext.Provider value={messageValue}>
      <GraphContext.Provider value={graphValue}>
        <TenantContext.Provider value={tenantValue}>
          <UserContext.Provider value={userValue}>
            <ProgressContext.Provider value={progressValue}>
              {children}
            </ProgressContext.Provider>
          </UserContext.Provider>
        </TenantContext.Provider>
      </GraphContext.Provider>
    </MessageContext.Provider>
  );
};

export default ContextWrapper;
